import React from 'react'
import '../App.css';
import { Navbar, Footer, TodosLosLibros} from '../container';

const SecBibliotecaTodos = () => {
  return (
    <div class="App_DB">
        <Navbar/> 
        <TodosLosLibros/>
        <Footer/>
    </div>
  )
}

export default SecBibliotecaTodos
